export default __webpack_public_path__ + "static/home-banner3-c5418632c8c26e8a44dea09906db03ad.jpg";